module.exports = __webpack_public_path__ + "img/latam.9f541a6.svg";